import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';
import { faqItems } from '@/mocks/books';
import { useInView } from '@/hooks/useInView';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { ref, inView } = useInView();

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  const anim = (inView: boolean) =>
    `transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`;

  return (
    <>
      <Navbar />
      <main className="pt-0">
        <section className="relative w-full min-h-[100svh] flex flex-col justify-center items-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Soft%20morning%20mist%20rising%20through%20mountain%20valleys%20between%20layered%20ridges%2C%20gentle%20warm%20light%20filtering%20through%20thin%20clouds%2C%20peaceful%20and%20calm%20alpine%20panorama%20with%20subtle%20green%20forested%20slopes%2C%20quiet%20contemplative%20atmosphere%2C%20natural%20muted%20earth%20tones%20with%20hints%20of%20golden%20light%2C%20fine%20art%20editorial%20landscape%20photography%2C%20atmospheric%20depth%20with%20soft%20focus%20on%20distant%20peaks%2C%20no%20snow%2C%20no%20water%2C%20no%20buildings%2C%20no%20people&width=1920&height=1080&seq=faq-hero-001&orientation=landscape"
              alt="常見問答 — 山脈晨霧層峰"
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-primary-950/65 via-primary-950/35 to-primary-950/55"></div>

          <div className="relative z-10 w-full px-6 md:px-10 pt-20 md:pt-24 pb-8">
          <div ref={ref} className={`max-w-3xl mx-auto w-full ${anim(inView)}`}>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-white text-center mb-4 text-shadow-section">
              常見問答
            </h1>
            <p className="text-center text-sm text-white/75 mb-12 max-w-xl mx-auto leading-relaxed text-shadow-section">
              品牌定位、出版方向與合作通路的常見疑問。
            </p>

            <div className="flex flex-col gap-3 mb-10">
              {faqItems.map((item, idx) => (
                <div
                  key={idx}
                  className="bg-white/10 backdrop-blur-sm rounded-lg overflow-hidden border border-white/10"
                >
                  <button
                    onClick={() => toggle(idx)}
                    className="w-full flex items-center justify-between px-6 py-5 text-left transition-colors hover:bg-white/15"
                  >
                    <h3 className="font-label font-medium text-sm md:text-base text-white pr-4 text-shadow-section">
                      {item.q}
                    </h3>
                    <span className={`flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-45' : ''}`}>
                      <i className="ri-add-line text-lg text-white/70"></i>
                    </span>
                  </button>
                  <div
                    className={`transition-all duration-300 overflow-hidden ${
                      openIndex === idx ? 'max-h-96 pb-5' : 'max-h-0'
                    }`}
                  >
                    <p className="px-6 text-sm text-white/70 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap justify-center gap-3">
              <Link
                to="/stores"
                className="px-5 py-3 bg-accent-500 text-primary-950 font-label font-semibold text-sm rounded-full hover:bg-accent-400 transition-all duration-300 whitespace-nowrap"
              >
                查看合作通路
              </Link>
              <a
                href="https://catalog.sonbook.net/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="px-5 py-3 bg-white/15 backdrop-blur-sm text-white font-label font-medium text-sm rounded-full hover:bg-white/25 border border-white/20 transition-all duration-300 whitespace-nowrap"
              >
                崧博出版書籍資料庫
              </a>
            </div>
          </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}